<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="'Work Queue'"></Teranet-PageTitle>
    <mat-tab-group #mattab [(selectedIndex)]="selectedIndex">
      <mat-tab *ngIf="isShowTab(queueName.LenderReconciliation)">
        <ng-template mat-tab-label>
          <div class="mat-tab-title">{{ queueName.LenderReconciliation }}</div>
        </ng-template>
        <div fxLayout="row wrap" *ngIf="isSelectedtab(selectedIndex, queueName.LenderReconciliation)">
          <div fxFlex="100">
            <Teranet-LenderReconciliationQueue [WorkQueueType]="2"></Teranet-LenderReconciliationQueue>
          </div>
        </div>
      </mat-tab>
      <mat-tab *ngIf="isShowTab(queueName.LenderRemediation)">
        <ng-template mat-tab-label>
          <div class="mat-tab-title">{{ queueName.LenderRemediation }}</div>
        </ng-template>
        <div fxLayout="row wrap" *ngIf="isSelectedtab(selectedIndex, queueName.LenderRemediation)">
          <div fxFlex="100">
            <Teranet-LenderRemediationQueue [WorkQueueType]="1"></Teranet-LenderRemediationQueue>
          </div>
        </div>
      </mat-tab>

      <mat-tab *ngIf="isShowTab(queueName.Watchlist)">
        <ng-template mat-tab-label>
          <div class="mat-tab-title">{{ queueName.Watchlist }}</div>
        </ng-template>
        <div fxLayout="row wrap" *ngIf="isSelectedtab(selectedIndex, queueName.Watchlist)">
          <div fxFlex="100">
            <Teranet-UsQueue [WorkQueueType]="3"></Teranet-UsQueue>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
